import React, { useEffect, useRef, useState } from 'react';
import Animate from '../Components/Animate';
import { useUser } from '../context/userContext';
import { useNavigate } from 'react-router-dom';
import { Address } from '../Components/Address';
import Exchanges from '../Components/Exchanges';
import { RiExchangeDollarFill } from "react-icons/ri";
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { CiNoWaitingSign } from 'react-icons/ci';

const Airdrop = () => {
  const { tonTransactions, refBonus, miningTotal, taskPoints, selectedExchange, balance } = useUser();
  const [showExchange, setShowExchange] = useState(false);
  const locations = useNavigate();
  const [backLos, setBackLos] = useState(true);
  const [openInfoTwo, setOpenInfoTwo] = useState(false);
  const infoRefTwo = useRef(null);

  const [tgUser, setTgUser] = useState({
    name: 'User - Name',
    id: 'telegram user id',
    photo: '/default-profile.png'
  });

  useEffect(() => {
    if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
      const user = window.Telegram.WebApp.initDataUnsafe.user;
      setTgUser({
        name: user.first_name || 'Telegram User',
        id: user.id || 'N/A',
        photo: user.photo_url || '/default-profile.png'
      });
    }
  }, []);

  const handleClickOutside = (event) => {
    if (infoRefTwo.current && !infoRefTwo.current.contains(event.target)) {
      setOpenInfoTwo(false);
    }
  };

  useEffect(() => {
    if (openInfoTwo) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openInfoTwo]);

  useEffect(() => {
    const handleBackButtonClick = () => {
      locations('/');
      setBackLos(false);
    };

    if (backLos) {
      window.Telegram.WebApp.BackButton.show();
      window.Telegram.WebApp.BackButton.onClick(handleBackButtonClick);
    } else {
      window.Telegram.WebApp.BackButton.hide();
      window.Telegram.WebApp.BackButton.offClick(handleBackButtonClick);
    }

    return () => {
      window.Telegram.WebApp.BackButton.offClick(handleBackButtonClick);
    };
  }, [backLos, locations]);

  const formatNumber = (num) => {
    if (!num) return '0';
    return new Intl.NumberFormat().format(num);
  };

  const qualifications = [
    { title: "Make TON Transactions", totalBalance: tonTransactions, icon: '/ton.png', id: 1 },
    { title: "Tasks Rewards", totalBalance: taskPoints, icon: '/coin.webp', id: 2 },
    { title: "Mining Rewards", totalBalance: miningTotal, icon: '/earn.png', id: 3 },
    { title: "Referral Rewards", totalBalance: refBonus, icon: '/ref.svg', id: 4 }
  ];

  const openExchange = () => setShowExchange(true);
  const showComingSoon = () => setOpenInfoTwo(true);

  return (
    <Animate>
      <div className='w-full h-screen flex flex-col bg-[#121212]'>
        {/* Header */}
        <div className='w-full px-5 pt-5'>
          <div className='flex justify-between items-center'>
            <div>
              <h1 className='text-[20px] font-bold text-white'>{tgUser.name}</h1>
              <p className='text-[14px] text-gray-400'>ID: {tgUser.id}</p>
            </div>
            <img
              src={tgUser.photo}
              alt="profile"
              className="w-[50px] h-[50px] rounded-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/default-profile.png';
              }}
            />
          </div>
        </div>

        {/* Balance */}
        <div className='w-full px-5 py-3'>
          <div className='bg-[#1E1E1E] rounded-xl p-4'>
            <div className='flex justify-between items-center mb-1'>
              <span className='text-gray-400'>Wallet Balance</span>
              <span className='text-[#0088CC]'>Voscoin</span>
            </div>
            <div className='text-[24px] font-bold text-white'>{formatNumber(balance || 0)}</div>
          </div>
        </div>

        {/* Address */}
        <div className='w-full px-5 pb-2'>
          <Address />
        </div>

        {/* Send/Receive Buttons */}
        <div className='w-full px-5 py-2 flex justify-between'>
          <button onClick={showComingSoon} className='bg-[#1E1E1E] text-white w-[48%] py-3 rounded-lg font-medium border border-[#0088CC]'>
            Send
          </button>
          <button onClick={showComingSoon} className='bg-[#1E1E1E] text-white w-[48%] py-3 rounded-lg font-medium border border-[#0088CC]'>
            Receive
          </button>
        </div>

        {/* Scrollable Content */}
        <div className='flex-1 overflow-y-auto px-5 pb-5'>
          <div className='w-full bg-[#1E1E1E] rounded-xl p-5'>
            <h1 className='font-semibold text-[20px] text-white text-center pb-2'>
              Airdrop Qualifiers
            </h1>
            <p className='text-[14px] text-[#c6c6c6] text-center pb-4'>
              Listing and launching soon, all activities are important for qualification!
            </p>

            {/* Exchange Select */}
            <button
              onClick={openExchange}
              className='w-full bg-[#2a2d2e] text-white text-[14px] rounded-[10px] px-4 py-4 flex items-center justify-between hover:bg-[#3a3d3e] transition-all duration-300 mb-4'
            >
              <div className='flex items-center space-x-3'>
                <RiExchangeDollarFill size={24} className="text-[#0088CC]" />
                <div className='text-left'>
                  <h2 className='font-medium'>Choose airdrop exchange</h2>
                  <p className='text-[13px] text-gray-400'>
                    {selectedExchange.id === 'selectex' ? "Select exchange" : selectedExchange.name}
                  </p>
                </div>
              </div>
              <MdOutlineKeyboardArrowRight size={20} className="text-[#0088CC]" />
            </button>

            {/* Qualification Items */}
            <div className='space-y-3'>
              {qualifications.map((data, index) => (
                <div
                  key={index}
                  className="w-full bg-[#2a2d2e] text-white text-[14px] rounded-[10px] px-4 py-3 flex items-center justify-between hover:bg-[#3a3d3e] transition-all duration-300"
                >
                  <div className="flex items-center space-x-3">
                    <img
                      src={data.icon}
                      alt={data.title}
                      className="w-[24px] h-[24px] rounded-full"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-icon.png';
                      }}
                    />
                    <span>{data.title}</span>
                  </div>
                  <span className={`font-medium ${data.totalBalance > 0 ? 'text-[#0088CC]' : 'text-gray-400'}`}>
                    {data.totalBalance > 0 ? '+' : ''}{formatNumber(data.totalBalance)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Coming Soon Modal */}
        <div className={`${openInfoTwo ? "visible" : "invisible"} fixed top-0 bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#000000cc] flex justify-center items-center backdrop-blur-[6px] px-4`}>
          <div ref={infoRefTwo} className={`${openInfoTwo ? "opacity-100 mt-0" : "opacity-0 mt-[100px]"} w-full bg-[#1E1E1E] rounded-[16px] flex flex-col justify-center p-8 transition-all duration-300`}>
            <div className="w-full flex justify-center flex-col items-center space-y-3">
              <CiNoWaitingSign size={50} className="text-[#0088CC]" />
              <h3 className="font-medium text-center text-[20px] text-white pt-2 pb-2">
                Coming Soon
              </h3>
              <p className="pb-6 text-[14px] w-full text-center text-gray-400">
                Loading! This feature will be available soon. Stay tuned!
              </p>
            </div>
            <button
              onClick={() => setOpenInfoTwo(false)}
              className="bg-[#0088CC] text-white w-full py-3 rounded-lg font-medium"
            >
              OK
            </button>
          </div>
        </div>

        <Exchanges showExchange={showExchange} setShowExchange={setShowExchange} />
      </div>
    </Animate>
  );
};

export default Airdrop;
